import { takeLatest, put, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { UpdateRouterQueryAction } from './actions';
import {
  locationPathnameSelector,
  locationQuerySelector,
} from '../router/selectors';
import queryString from 'qs';

export interface MatchParams {
  id?: string;
  name?: string;
}

export const updateQuery = (
  pathname: string,
  query: Record<string, string>
): string => {
  const newQuery = queryString.stringify(query);
  if (newQuery.length > 0) {
    return `${pathname}?${newQuery}`;
  }
  return pathname;
};

export function* updateRouterQuery(action: UpdateRouterQueryAction) {
  const pathname: string = yield select(locationPathnameSelector);
  const query: Record<string, string> = yield select(locationQuerySelector);

  const { updates } = action;
  for (const update of updates) {
    const { type, key } = update;
    switch (type) {
      case 'add': {
        const { value } = update;
        if (!value) {
          continue;
        }
        query[key] = value;
        break;
      }
      case 'delete':
        delete query[key];
        break;
    }
  }

  yield put(push(updateQuery(pathname, query)));
}

export function* sagas() {
  yield takeLatest('ROUTER/UPDATE_QUERY', updateRouterQuery);
}
